module.exports = __webpack_public_path__ + "img/btc_cryptocurrencies_icon_188406.23c4efe.svg";